export enum PinwheelScreens {
  SEARCH_DEFAULT = 'SEARCH_DEFAULT',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SEARCH_PLATFORM_ONLY = 'SEARCH_PLATFORM_ONLY',
  PROVIDER_CONFIRMATION = 'PROVIDER_CONFIRMATION',
  LOGIN = 'LOGIN',
  DD_AMOUNT_SELECTION = 'DD_AMOUNT_SELECTION',
  DD_CONFIRMATION = 'DD_CONFIRMATION',
  JOB_SUCCESS = 'JOB_SUCCESS',
  JOB_ERROR = 'JOB_ERROR',
  MANUAL_INSTRUCTIONS = 'MANUAL_INSTRUCTIONS',
  BILL_SWITCH_INTRO = 'BILL_SWITCH_INTRO',
  BILL_SWITCH_ACCOUNTS = 'BILL_SWITCH_ACCOUNTS',
  BILL_SWITCH_MERCHANT_LIST = 'BILL_SWITCH_MERCHANT_LIST',
  BILL_SWITCH_MERCHANT = 'BILL_SWITCH_MERCHANT',
  PLAID_MODAL = 'PLAID_MODAL',
  RECURRENCES_FOUND = 'RECURRENCES_FOUND',
  BILL_SWITCH_MANUAL = 'BILL_SWITCH_MANUAL',
  BILL_SWITCH_PAYMENT_METHOD = 'BILL_SWITCH_PAYMENT_METHOD',
  BILL_SWITCH_TRANSACTIONS = 'BILL_SWITCH_TRANSACTIONS',
  BILL_SWITCH_SUCCESS = 'BILL_SWITCH_SUCCESS',
  BILL_SWITCH_FAILURE = 'BILL_SWITCH_FAILURE',
  BILL_CANCEL_MANUAL = 'BILL_CANCEL_MANUAL',
  BILL_CANCEL_MERCHANT = 'BILL_CANCEL_MERCHANT',
  BILL_MANAGER_ACCOUNTS = 'BILL_MANAGER_ACCOUNTS',
  BILL_MANAGER_CALENDAR = 'BILL_MANAGER_CALENDAR',
  BILL_MANAGER_CALENDAR_SYNC = 'BILL_MANAGER_CALENDAR_SYNC',
  BILL_MANAGER_DASHBOARD = 'BILL_MANAGER_DASHBOARD',
  BILL_MANAGER_INTRO = 'BILL_MANAGER_INTRO',
  BILL_MANAGER_LIST = 'BILL_MANAGER_LIST',
  BILL_MANAGER_RECURRENCE = 'BILL_MANAGER_RECURRENCE',
  BILL_MANAGER_RECURRENCE_ADD = 'BILL_MANAGER_RECURRENCE_ADD',
  BILL_MANAGER_RECURRENCE_EDIT = 'BILL_MANAGER_RECURRENCE_EDIT',
  BILL_MANAGER_SUPPORT = 'BILL_MANAGER_SUPPORT',
  EXIT_CONFIRMATION = 'EXIT_CONFIRMATION',
}
